/**
 * Determines whether a professional should use supplier-style enquiry copy.
 * This covers manufacturers as well as other product-led profiles.
 */
export function isProductSupplierProfessional({
    isManufacturer,
    hasProducts,
    productsAllowed,
}: {
    isManufacturer?: boolean | null;
    hasProducts?: boolean | null;
    productsAllowed?: boolean | null;
}) {
    return Boolean(isManufacturer || hasProducts || productsAllowed);
}
